import { AppState_getInstance33x03n2an9aul as AppState_getInstance } from '../../../../../../kiteui-library/com/lightningkite/kiteui/reactive/AppState.js.mjs';
import { get_stringsy7vodl9dj0ya as get_strings } from '../../strings.mjs';
import { get_currentSessionNotNull30vuua77prq38 as get_currentSessionNotNull } from '../../sdk/currentSession.mjs';
import {
  await1uwe8zvsjq69o as await_0,
  await1xlt6i5aa076q as await_1,
} from '../../../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
import { orPromise1iucc2to2udt2 as orPromise } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/coroutinesInteropJs.mjs';
import {
  constructCallableReference23y65rf941mch as constructCallableReference,
  getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { Companion_instance177q6f44m9gy2 as Companion_instance } from '../components/remittanceBreakdownGrid.mjs';
import { ChildPlacementDetailPagewfmc55i6s15v as ChildPlacementDetailPage } from '../children/ChildPlacementDetailPage.mjs';
import {
  ID1z61wlmtvxrjn as ID,
  ID1m87d1hextx54 as ID_0,
} from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/domain.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import {
  ensureOutermostElement1f4fzdv7yw0ql as ensureOutermostElement,
  Companion_getInstanceztgx4sy4wjnt as Companion_getInstance,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/NativeElement.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import {
  TextView$_get_content_$ref_4pzcwl5a4gnldk8ef9 as TextView$_get_content_$ref_4pzcwl,
  TextView$_set_content_$ref_pketfb11e282hr0m0jl as TextView$_set_content_$ref_pketfb,
} from '../../App.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { get_pageNavigatorp3to6r4j8ctv as get_pageNavigator } from '../../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Navigator.mjs';
import { RemittanceDetailPage384df89l74tfl as RemittanceDetailPage } from './RemittanceDetailPage.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { confirmationDialoginprr3lfvaqc as confirmationDialog } from '../components/dialogs.mjs';
import { RowOrCol3a33s3yce2tuv as RowOrCol } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/LinearLayouts.commonHtml.mjs';
import {
  DangerSemantic_getInstance1xd9zwrvs99lp as DangerSemantic_getInstance,
  CardSemantic_getInstancelcny5le8pbc4 as CardSemantic_getInstance,
  ImportantSemantic_getInstancehm7lt56tp87l as ImportantSemantic_getInstance,
  ButtonSemantic_getInstance3q30xblp6a1af as ButtonSemantic_getInstance,
  HeaderSemantic_getInstance20a9id3sf7d4x as HeaderSemantic_getInstance,
  get_H1Semantic28sytsa4fm6nk as get_H1Semantic,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import {
  themed2vu67ornd4jps as themed,
  get_bold3d63kt1t4c9r5 as get_bold,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/themeDerivations.mjs';
import { Link2eefk0yp041c4 as Link } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Link.commonHtml.mjs';
import { subtext2yjmf1ok7kb40 as subtext } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/shortcuts.mjs';
import {
  remittanceSummary7eycmz4clrlq as remittanceSummary,
  remittanceChildTotals1vleuy0834qvm as remittanceChildTotals,
  monthStarting2k0geg6vqg7e9 as monthStarting,
} from './remittanceComponents.mjs';
import {
  weight31wqab1913ly4 as weight,
  shownWhen3t7othivfr11 as shownWhen,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.commonHtml.mjs';
import { Spaceoq5xo9lsieqc as Space } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Space.commonHtml.mjs';
import { Button263cw152yl80e as Button } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.commonHtml.mjs';
import {
  Cents__toString_impl_ko5hxm1a9pwstsznn43 as Cents__toString_impl_ko5hxm,
  Cents1lsbs5l1tlgw as Cents,
} from '../../../../../../service-abstractions-currency/com/lightningkite/services/data/Cents.mjs';
import {
  Button$_get_enabled_$ref_61t7nx58ibx9ifxb3n as Button$_get_enabled_$ref_61t7nx,
  Button$_set_enabled_$ref_o8kynzfmpduwei6tot as Button$_set_enabled_$ref_o8kynz,
} from '../applications/FamilyApplicationDetailPage.mjs';
import { Action2nhdpxpznfsbd as Action } from '../../../../../../kiteui-library/com/lightningkite/kiteui/reactive/Action.mjs';
import {
  Companion_instance1lm8x0jadqh2g as Companion_instance_0,
  Platform_Web_getInstance2840w5bkfolz8 as Platform_Web_getInstance,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/Platform.mjs';
import { get_current2r182tjucmm5v as get_current } from '../../../../../../kiteui-library/com/lightningkite/kiteui/Platform.js.mjs';
import { ProviderPeriod3npnb7yy6xoeh as ProviderPeriod } from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/money.mjs';
import { remember2m0mx1b5ra75q as remember } from '../../../../../../reactive/com/lightningkite/reactive/core/Remember.mjs';
import { get_scrolling3fwkltztkpfe8 as get_scrolling } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import {
  maxWidth22r11xnm7d4h4 as maxWidth,
  goBackButton1g9k0xsmfm57i as goBackButton,
} from '../components/view-utilities.mjs';
import { rememberSuspending14xvgr29y3z54 as rememberSuspending } from '../../../../../../reactive/com/lightningkite/reactive/core/RememberSuspending.mjs';
import { get_centered31th09q7x90sf as get_centered } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import { SwapView1526g6cz7z56r as SwapView } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/SwapView.commonHtml.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { Companion_getInstance29ka8gqgdrya1 as Companion_getInstance_0 } from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/ScreenTransitions.mjs';
import { Exceptiondt2hlxn7j7vw as Exception } from '../../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { toString30pk9tzaqopn as toString } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { report1vfr9zf0i9d9p as report } from '../../../../../../kiteui-library/com/lightningkite/kiteui/debugger.mjs';
import { reactive2xic0rufq5s8n as reactive } from '../../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import { Page1o437w9xuocrm as Page } from '../../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Page.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function RemittanceReviewPage$_get_title_$lambda_wvbu9d($this$remember) {
  return $this$remember.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_remittanceReviewPageTitle_w5gryu_k$();
}
function RemittanceReviewPage$render$slambda(this$0) {
  return constructCallableReference(($this$rememberSuspending, $completion) => orPromise($completion, function *($completion) {
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = get_currentSessionNotNull();
    return yield* (yield* await_0(this_0, $completion)).api_1.get_careProviderRemittance_7bo3o7_k$().previewRemittance_ywbd9v_k$(this$0.period_1, $completion);
  }), 1);
}
function RemittanceReviewPage$render$slambda_0($proposal) {
  return constructCallableReference(($this$rememberSuspending, $completion) => orPromise($completion, function *($completion) {
    var tmp = Companion_instance;
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = $proposal;
    var tmp$ret$0 = yield* await_0(this_0, $completion);
    return yield* tmp.calculate_mx8h7j_k$(tmp$ret$0.days_1, $completion);
  }), 1);
}
function RemittanceReviewPage$render$lambda$lambda$lambda($problem) {
  return () => new (ChildPlacementDetailPage())($problem.placement_1);
}
function RemittanceReviewPage$render$lambda$lambda$lambda_0($problem) {
  return ($this$invoke) => {
    var tmp0_safe_receiver = $this$invoke.invoke_r7m7el_k$($this$invoke.invoke_r7m7el_k$(get_currentSessionNotNull()).get_careLocations_f1rtw_k$().get_6ueaa7_k$(new (ID())($problem.location_1)));
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.name_1;
    return $problem.childName_1 + ' \xB7 ' + (tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs);
  };
}
function RemittanceReviewPage$render$lambda$lambda$slambda$lambda($this$confirmationDialog) {
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element = new (TextView())($this$confirmationDialog.get_context_h02k06_k$());
  ensureOutermostElement(element);
  $this$confirmationDialog.willAddChild_hz2iwc_k$(element);
  var tmp = KMutableProperty0();
  var tmp_0 = TextView$_get_content_$ref_4pzcwl(element);
  var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element));
  element.invoke_bnq13k_k$(tmp_1, RemittanceReviewPage$render$lambda$lambda$slambda$lambda$lambda);
  element.onStartup_vrxh3i_k$();
  $this$confirmationDialog.addChild_2qpft2_k$(element);
  return Unit_instance;
}
function RemittanceReviewPage$render$lambda$lambda$slambda$lambda$lambda($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_remittanceIssueConfirmBody_1w6k7k_k$();
}
function RemittanceReviewPage$render$lambda$lambda$slambda$slambda(this$0, $$this$button) {
  return constructCallableReference(($completion) => orPromise($completion, function *($completion) {
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = get_currentSessionNotNull();
    var session = yield* await_0(this_0, $completion);
    var issued = yield* session.api_1.get_careProviderRemittance_7bo3o7_k$().issueRemittance_eyg3pc_k$(this$0.period_1, $completion);
    session.get_careProviderRemittances_dyezti_k$().localInsert_9xyne_k$(issued);
    get_pageNavigator($$this$button.get_context_h02k06_k$()).replace_7qh33u_k$(new (RemittanceDetailPage())(issued._id_1));
    return Unit_instance;
  }), 0);
}
function RemittanceReviewPage$render$lambda$lambda$slambda($$this$button, this$0) {
  return constructCallableReference(($this$Action, $completion) => orPromise($completion, function *($completion) {
    var tmp = $$this$button.get_context_h02k06_k$();
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = get_strings(AppState_getInstance());
    var tmp_0 = (yield* await_1(this_0, $completion)).get_remittanceIssueConfirmHeading_bxfsjw_k$();
    var tmp_1 = RemittanceReviewPage$render$lambda$lambda$slambda$lambda;
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_1 = get_strings(AppState_getInstance());
    var tmp_2 = (yield* await_1(this_1, $completion)).get_remittanceIssueConfirmButton_qtcw1s_k$();
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_2 = get_strings(AppState_getInstance());
    var tmp_3 = (yield* await_1(this_2, $completion)).get_crudCancelButton_yk4tir_k$();
    confirmationDialog(tmp, tmp_0, tmp_1, tmp_2, VOID, tmp_3, VOID, RemittanceReviewPage$render$lambda$lambda$slambda$slambda(this$0, $$this$button));
    return Unit_instance;
  }), 1);
}
function RemittanceReviewPage$render$lambda$lambda($next, this$0) {
  return ($this$swap) => {
    var proposed = $next;
    // Inline function 'com.lightningkite.kiteui.views.direct.col' call
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element = new (RowOrCol())($this$swap.get_context_h02k06_k$());
    ensureOutermostElement(element);
    $this$swap.willAddChild_hz2iwc_k$(element);
    element.set_vertical_nuap32_k$(true);
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!proposed.problems_1.isEmpty_y1axqb_k$()) {
      // Inline function 'com.lightningkite.kiteui.views.danger' call
      // Inline function 'com.lightningkite.kiteui.views.card' call
      var this_0 = themed(element, DangerSemantic_getInstance());
      // Inline function 'com.lightningkite.kiteui.views.direct.col' call
      var this_1 = themed(this_0, CardSemantic_getInstance());
      // Inline function 'com.lightningkite.kiteui.views.write' call
      var element_0 = new (RowOrCol())(this_1.get_context_h02k06_k$());
      ensureOutermostElement(element_0);
      this_1.willAddChild_hz2iwc_k$(element_0);
      element_0.set_vertical_nuap32_k$(true);
      // Inline function 'com.lightningkite.kiteui.views.direct.text' call
      var this_2 = get_bold(element_0);
      // Inline function 'com.lightningkite.kiteui.views.write' call
      var element_1 = new (TextView())(this_2.get_context_h02k06_k$());
      ensureOutermostElement(element_1);
      this_2.willAddChild_hz2iwc_k$(element_1);
      var tmp = KMutableProperty0();
      var tmp_0 = TextView$_get_content_$ref_4pzcwl(element_1);
      var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element_1));
      element_1.invoke_bnq13k_k$(tmp_1, ($this$invoke) => $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).remittanceProblemsHeading_lc0nvc_k$(proposed.problems_1.get_size_woubt6_k$()));
      element_1.onStartup_vrxh3i_k$();
      this_2.addChild_2qpft2_k$(element_1);
      var _iterator__ex2g4s = proposed.problems_1.iterator_jk1svi_k$();
      while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
        var problem = _iterator__ex2g4s.next_20eer_k$();
        // Inline function 'com.lightningkite.kiteui.views.direct.link' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_2 = new (Link())(element_0.get_context_h02k06_k$());
        ensureOutermostElement(element_2);
        element_0.willAddChild_hz2iwc_k$(element_2);
        element_2.set_to_opdqsp_k$(RemittanceReviewPage$render$lambda$lambda$lambda(problem));
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_3 = new (RowOrCol())(element_2.get_context_h02k06_k$());
        ensureOutermostElement(element_3);
        element_2.willAddChild_hz2iwc_k$(element_3);
        element_3.set_vertical_nuap32_k$(true);
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_4 = new (TextView())(element_3.get_context_h02k06_k$());
        ensureOutermostElement(element_4);
        element_3.willAddChild_hz2iwc_k$(element_4);
        var tmp_2 = KMutableProperty0();
        var tmp_3 = TextView$_get_content_$ref_4pzcwl(element_4);
        var tmp_4 = getPropertyCallableRef('content', 0, tmp_2, tmp_3, TextView$_set_content_$ref_pketfb(element_4));
        element_4.invoke_bnq13k_k$(tmp_4, RemittanceReviewPage$render$lambda$lambda$lambda_0(problem));
        element_4.onStartup_vrxh3i_k$();
        element_3.addChild_2qpft2_k$(element_4);
        subtext(element_3, problem.message_1);
        element_3.onStartup_vrxh3i_k$();
        element_2.addChild_2qpft2_k$(element_3);
        element_2.onStartup_vrxh3i_k$();
        element_0.addChild_2qpft2_k$(element_2);
      }
      element_0.onStartup_vrxh3i_k$();
      this_1.addChild_2qpft2_k$(element_0);
    }
    remittanceSummary(element, proposed.days_1);
    // Inline function 'com.lightningkite.kiteui.views.direct.row' call
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_5 = new (RowOrCol())(element.get_context_h02k06_k$());
    ensureOutermostElement(element_5);
    element.willAddChild_hz2iwc_k$(element_5);
    element_5.set_vertical_nuap32_k$(false);
    // Inline function 'com.lightningkite.kiteui.views.expanding' call
    // Inline function 'com.lightningkite.kiteui.views.direct.space' call
    var this_3 = weight(element_5, 1.0);
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_6 = new (Space())(this_3.get_context_h02k06_k$());
    ensureOutermostElement(element_6);
    this_3.willAddChild_hz2iwc_k$(element_6);
    element_6.onStartup_vrxh3i_k$();
    this_3.addChild_2qpft2_k$(element_6);
    // Inline function 'com.lightningkite.kiteui.views.important' call
    // Inline function 'com.lightningkite.kiteui.views.buttonTheme' call
    var this_4 = themed(element_5, ImportantSemantic_getInstance());
    // Inline function 'com.lightningkite.kiteui.views.direct.button' call
    var this_5 = themed(this_4, ButtonSemantic_getInstance());
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_7 = new (Button())(this_5.get_context_h02k06_k$());
    ensureOutermostElement(element_7);
    this_5.willAddChild_hz2iwc_k$(element_7);
    // Inline function 'com.lightningkite.kiteui.views.direct.text' call
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_8 = new (TextView())(element_7.get_context_h02k06_k$());
    ensureOutermostElement(element_8);
    element_7.willAddChild_hz2iwc_k$(element_8);
    var tmp_5 = KMutableProperty0();
    var tmp_6 = TextView$_get_content_$ref_4pzcwl(element_8);
    var tmp_7 = getPropertyCallableRef('content', 0, tmp_5, tmp_6, TextView$_set_content_$ref_pketfb(element_8));
    element_8.invoke_bnq13k_k$(tmp_7, ($this$invoke) => $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).remittanceIssueButton_tu58r7_k$(Cents__toString_impl_ko5hxm(proposed.remittance_1.amount_1)));
    element_8.onStartup_vrxh3i_k$();
    element_7.addChild_2qpft2_k$(element_8);
    var tmp_8 = KMutableProperty0();
    var tmp_9 = Button$_get_enabled_$ref_61t7nx(element_7);
    var tmp_10 = getPropertyCallableRef('enabled', 0, tmp_8, tmp_9, Button$_set_enabled_$ref_o8kynz(element_7));
    element_7.invoke_bnq13k_k$(tmp_10, ($this$invoke) => {
      var tmp;
      if (proposed.problems_1.isEmpty_y1axqb_k$()) {
        // Inline function 'kotlin.collections.isNotEmpty' call
        tmp = !proposed.days_1.isEmpty_y1axqb_k$();
      } else {
        tmp = false;
      }
      return tmp;
    });
    element_7.set_action_2ds022_k$(Action('Issue remittance', VOID, VOID, VOID, VOID, VOID, RemittanceReviewPage$render$lambda$lambda$slambda(element_7, this$0)));
    element_7.onStartup_vrxh3i_k$();
    this_5.addChild_2qpft2_k$(element_7);
    element_5.onStartup_vrxh3i_k$();
    element.addChild_2qpft2_k$(element_5);
    element.onStartup_vrxh3i_k$();
    $this$swap.addChild_2qpft2_k$(element);
    return Unit_instance;
  };
}
function RemittanceReviewPage$render$lambda$lambda_0($next, this$0) {
  return ($this$swap) => {
    var it = $next;
    remittanceChildTotals($this$swap, it, this$0.period_1.forDates_1);
    return Unit_instance;
  };
}
function RemittanceReviewPage$render$lambda$lambda$lambda_1(day) {
  return new (Cents())(day.totalContributions_1);
}
function RemittanceReviewPage$render$lambda$lambda_1($next) {
  return ($this$swap) => {
    $next.render_b3nvws_k$($this$swap, RemittanceReviewPage$render$lambda$lambda$lambda_1);
    return Unit_instance;
  };
}
function RemittanceReviewPage$render$lambda($this$shownWhen) {
  return get_current(Companion_instance_0).equals(Platform_Web_getInstance());
}
var RemittanceReviewPageClass;
function RemittanceReviewPage() {
  if (RemittanceReviewPageClass === VOID) {
    class $ {
      constructor(provider, month) {
        this.provider_1 = provider;
        this.month_1 = month;
        this.period_1 = new (ProviderPeriod())(this.provider_1, monthStarting(this.month_1));
      }
      get_title_iz32un_k$() {
        return remember(VOID, VOID, VOID, VOID, RemittanceReviewPage$_get_title_$lambda_wvbu9d);
      }
      render_w3x9d1_k$(_this__u8e3s4) {
        // Inline function 'org.thecommunitygroupinc.cares.views.components.page' call
        var this_0 = get_scrolling(_this__u8e3s4);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        var this_1 = maxWidth(this_0);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element = new (RowOrCol())(this_1.get_context_h02k06_k$());
        ensureOutermostElement(element);
        this_1.willAddChild_hz2iwc_k$(element);
        element.set_vertical_nuap32_k$(true);
        element.set_themeBase_daz04n_k$(Companion_getInstance().fromParentNonCascading_1);
        var proposal = rememberSuspending(VOID, VOID, VOID, RemittanceReviewPage$render$slambda(this));
        var grid = rememberSuspending(VOID, VOID, VOID, RemittanceReviewPage$render$slambda_0(proposal));
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_0 = new (RowOrCol())(element.get_context_h02k06_k$());
        ensureOutermostElement(element_0);
        element.willAddChild_hz2iwc_k$(element_0);
        element_0.set_vertical_nuap32_k$(false);
        goBackButton(get_centered(element_0));
        // Inline function 'com.lightningkite.kiteui.views.expanding' call
        var this_2 = get_centered(element_0);
        // Inline function 'com.lightningkite.kiteui.views.direct.h1' call
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        var this_3 = weight(this_2, 1.0);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_1 = new (TextView())(this_3.get_context_h02k06_k$());
        ensureOutermostElement(element_1);
        this_3.willAddChild_hz2iwc_k$(element_1);
        element_1.set_themeChoice_py59um_k$(element_1.get_themeChoice_22tyn3_k$().plus_duvq05_k$(HeaderSemantic_getInstance().plus_duvq05_k$(get_H1Semantic())));
        var tmp = KMutableProperty0();
        var tmp_0 = TextView$_get_content_$ref_4pzcwl(element_1);
        var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element_1));
        element_1.invoke_bnq13k_k$(tmp_1, ($this$invoke) => {
          var tmp = $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance()));
          var tmp0_safe_receiver = $this$invoke.invoke_r7m7el_k$($this$invoke.invoke_r7m7el_k$(get_currentSessionNotNull()).get_careProviders_b5tc2w_k$().get_6ueaa7_k$(new (ID_0())(this.provider_1)));
          var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.name_1;
          return tmp.remittanceReviewHeading_bk4mmq_k$(tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs);
        });
        element_1.onStartup_vrxh3i_k$();
        this_3.addChild_2qpft2_k$(element_1);
        element_0.onStartup_vrxh3i_k$();
        element.addChild_2qpft2_k$(element_0);
        subtext(element, this.period_1.forDates_1.toString());
        // Inline function 'com.lightningkite.kiteui.views.direct.swapping' call
        // Inline function 'com.lightningkite.kiteui.views.direct.swapView' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_2 = new (SwapView())(element.get_context_h02k06_k$());
        ensureOutermostElement(element_2);
        element.willAddChild_hz2iwc_k$(element_2);
        // Inline function 'com.lightningkite.kiteui.views.direct.swapping' call
        var this_4 = element_2;
        var queue = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
        var alreadySwapping = {_v: false};
        reactive(this_4, 8, ($this$reactive) => {
          var c = $this$reactive.invoke_r7m7el_k$(proposal);
          queue.add_utx5q5_k$(c);
          var tmp;
          if (alreadySwapping._v) {
            return Unit_instance;
          }
          alreadySwapping._v = true;
          $l$loop: while (true) {
            // Inline function 'kotlin.collections.isNotEmpty' call
            if (!!queue.isEmpty_y1axqb_k$()) {
              break $l$loop;
            }
            var next = queue.removeAt_6niowx_k$(0);
            try {
              var tmp_0 = Companion_getInstance_0().Fade_1;
              this_4.swap_26x94b_k$(tmp_0, RemittanceReviewPage$render$lambda$lambda(next, this));
            } catch ($p) {
              if ($p instanceof Exception()) {
                var e = $p;
                report(Exception().new_kotlin_Exception_9qyiel_k$('Failed to render ' + toString(next), e), 'SwapView.swapping');
              } else {
                throw $p;
              }
            }
          }
          alreadySwapping._v = false;
          return Unit_instance;
        });
        element_2.onStartup_vrxh3i_k$();
        element.addChild_2qpft2_k$(element_2);
        // Inline function 'com.lightningkite.kiteui.views.direct.swapping' call
        // Inline function 'com.lightningkite.kiteui.views.direct.swapView' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_3 = new (SwapView())(element.get_context_h02k06_k$());
        ensureOutermostElement(element_3);
        element.willAddChild_hz2iwc_k$(element_3);
        // Inline function 'com.lightningkite.kiteui.views.direct.swapping' call
        var this_5 = element_3;
        var queue_0 = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
        var alreadySwapping_0 = {_v: false};
        reactive(this_5, 8, ($this$reactive) => {
          var c = $this$reactive.invoke_r7m7el_k$(grid);
          queue_0.add_utx5q5_k$(c);
          var tmp;
          if (alreadySwapping_0._v) {
            return Unit_instance;
          }
          alreadySwapping_0._v = true;
          $l$loop_0: while (true) {
            // Inline function 'kotlin.collections.isNotEmpty' call
            if (!!queue_0.isEmpty_y1axqb_k$()) {
              break $l$loop_0;
            }
            var next = queue_0.removeAt_6niowx_k$(0);
            try {
              var tmp_0 = Companion_getInstance_0().Fade_1;
              this_5.swap_26x94b_k$(tmp_0, RemittanceReviewPage$render$lambda$lambda_0(next, this));
            } catch ($p) {
              if ($p instanceof Exception()) {
                var e = $p;
                report(Exception().new_kotlin_Exception_9qyiel_k$('Failed to render ' + toString(next), e), 'SwapView.swapping');
              } else {
                throw $p;
              }
            }
          }
          alreadySwapping_0._v = false;
          return Unit_instance;
        });
        element_3.onStartup_vrxh3i_k$();
        element.addChild_2qpft2_k$(element_3);
        // Inline function 'com.lightningkite.kiteui.views.direct.swapping' call
        // Inline function 'com.lightningkite.kiteui.views.direct.swapView' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_4 = new (SwapView())(element.get_context_h02k06_k$());
        ensureOutermostElement(element_4);
        element.willAddChild_hz2iwc_k$(element_4);
        // Inline function 'com.lightningkite.kiteui.views.direct.swapping' call
        var this_6 = element_4;
        var queue_1 = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
        var alreadySwapping_1 = {_v: false};
        reactive(this_6, 8, ($this$reactive) => {
          var c = $this$reactive.invoke_r7m7el_k$(grid);
          queue_1.add_utx5q5_k$(c);
          var tmp;
          if (alreadySwapping_1._v) {
            return Unit_instance;
          }
          alreadySwapping_1._v = true;
          $l$loop_1: while (true) {
            // Inline function 'kotlin.collections.isNotEmpty' call
            if (!!queue_1.isEmpty_y1axqb_k$()) {
              break $l$loop_1;
            }
            var next = queue_1.removeAt_6niowx_k$(0);
            try {
              var tmp_0 = Companion_getInstance_0().Fade_1;
              this_6.swap_26x94b_k$(tmp_0, RemittanceReviewPage$render$lambda$lambda_1(next));
            } catch ($p) {
              if ($p instanceof Exception()) {
                var e = $p;
                report(Exception().new_kotlin_Exception_9qyiel_k$('Failed to render ' + toString(next), e), 'SwapView.swapping');
              } else {
                throw $p;
              }
            }
          }
          alreadySwapping_1._v = false;
          return Unit_instance;
        });
        element_4.onStartup_vrxh3i_k$();
        element.addChild_2qpft2_k$(element_4);
        // Inline function 'com.lightningkite.kiteui.views.direct.space' call
        var this_7 = shownWhen(element, VOID, VOID, RemittanceReviewPage$render$lambda);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_5 = new (Space())(this_7.get_context_h02k06_k$(), 1.0);
        ensureOutermostElement(element_5);
        this_7.willAddChild_hz2iwc_k$(element_5);
        element_5.onStartup_vrxh3i_k$();
        this_7.addChild_2qpft2_k$(element_5);
        element.onStartup_vrxh3i_k$();
        this_1.addChild_2qpft2_k$(element);
        return Unit_instance;
      }
    }
    initMetadataForClass($, 'RemittanceReviewPage', VOID, VOID, [Page()]);
    RemittanceReviewPageClass = $;
  }
  return RemittanceReviewPageClass;
}
//region block: exports
export {
  RemittanceReviewPage as RemittanceReviewPage1y592xgwqobqi,
};
//endregion

//# sourceMappingURL=RemittanceReviewPage.mjs.map
